<div class="container" id="bottom-slide-sheet" [ngClass]="{'container-show':show,'container-hide':!show}"
    (click)="onClick($event)" (mousedown)="onClick($event)">
    <div class="header-line">
        <div class="header-left h3-regular">Keyboard Shortcuts</div>
        <div class="header-right">
            <div class="keyboard h3-regular">Shift</div>
            <div class="keyboard h3-regular">?</div>
            <div class="h3-regular keyboard-tips">Show/Hide Keyboard Shortcuts</div>
            <div class="icon-container" (click)="close($event)">
                <smart-icon name="close"></smart-icon>
            </div>
        </div>
    </div>
    <div class="content-line">
        <div class="one-content">
            <div class="keyboard h3-regular">/</div>
            <div class="h3-regular keyboard-tips">or</div>
            <div class="keyboard h3-regular">s</div>
            <div class="h3-regular content-tips">Global Search</div>
        </div>
        <div class="one-content">
            <div class="keyboard h3-regular">f</div>
            <div class="h3-regular content-tips">Quick Find</div>
        </div>
        <div class="one-content">
            <div class="keyboard h3-regular">n</div>
            <div class="h3-regular content-tips">New Note</div>
        </div>
        <div class="one-content">
            <div class="keyboard h3-regular">e</div>
            <div class="h3-regular content-tips">New Entity</div>
        </div>
        <div class="one-content">
            <div class="keyboard h3-regular">c</div>
            <div class="h3-regular content-tips">New Contact</div>
        </div>
        <div class="one-content">
            <div class="keyboard h3-regular">p</div>
            <div class="h3-regular content-tips">Print Note</div>
        </div>
    </div>
</div>